import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';

const useAccreditation = id => {
  const path = `${API_ENDPOINTS.ACCREDITATIONS}/${id}`;
  const { t } = useTranslation(LOCALIZATION_PAGES.EVENTIVAL_ACCREDITATIONS);
  const { showNotification } = useRoot();
  const [{ result: accreditation, loading, error }, getAccreditation] = useApi(path);

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('accreditation_fetch_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  return [{ accreditation, loading }, getAccreditation];
};

export default useAccreditation;
